import logo from 'assets/images/sta-logo-white-116.png';

// ==============================|| LOGO ||============================== //

const Logo = () => <img src={logo} alt="STA" width="116" />;

export default Logo;
